<template>
    <div class="proyectospage">
        <Navbar/>
        <b-container fluid id="inicio" class="banner">
            <b-row class="banner-section align-items-center">
                <b-col md="5" sm="12">
                    <h4>Proyectos</h4>
                    <p>En ARIA LIFE hemos logrado integrar valores que nos permiten mantenernos siempre separados de la monotonía inmobiliaria. Por el contrario hemos cohesionado cuatro factores que nos han permitido diferenciarnos en el mercado</p>
                </b-col>
            </b-row>
        </b-container>
        <b-container>
            <b-row class="m-auto factores-section">
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-3" src="../assets/imgs/iconoestilo.svg" alt="">
                    <p class="mb-0"><b>Diseño Moderno y Estilo Atemporal:</b></p>
                    <p>Creaciones que armonizan con las tendencias actuales y permanecen relevantes con el paso del tiempo.</p>
                </b-col>
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-3" src="../assets/imgs/iconoubi.svg" alt="">
                    <p class="mb-0"><b>Ubicaciones Estratégicas:</b></p>
                    <p>Proyectos situados en puntos clave que combinan conectividad, comodidad y plusvalía.</p>
                </b-col>
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-5" src="../assets/imgs/iconoconfianza.svg" alt="">
                    <p class="mb-0"><b>Trayectoria y Confianza: </b></p>
                    <p> Años de experiencia respaldan nuestra reputación como un desarrollador de confianza. </p>
                </b-col>
                <b-col class="mb-5 text-center" align-self="end" md="6">
                    <img class="mb-3" src="../assets/imgs/iconoatencionp.svg" alt="">
                    <p class="mb-0"><b>Atención Personalizada:</b></p>
                    <p>Entendemos las necesidades únicas de nuestros clientes y trabajamos para superarlas.</p>
                </b-col>
            </b-row>
        </b-container>
        <b-container fluid>
            <b-row class="proyectos" >
                <b-col lg="12" class="wrapper-proyectos-logos mb-5">
                    <b-row>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logosantamaria.svg" alt="">
                        </b-col>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logocoto1.svg" alt="">
                        </b-col>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logocoto2.svg" alt="">
                        </b-col>
                        <b-col align-self="center" class="mb-3 mt-3 text-center" md="3">
                            <img class="img-fluid" src="../assets/imgs/logosamara.svg" alt="">
                        </b-col>
                    </b-row>
                </b-col>
                <b-col>
                    <p class="text-proyectos text-center m-auto"> Actualmente contamos con tres proyectos en etapas de lanzamiento y operación. Proyectos que obedecen a mercados de vivienda media, media alta y residencial. Así como llevando una cobertura geográfica integral de la oferta de vivienda en la ciudad.</p>
                </b-col>
            </b-row>
        </b-container>
        <b-container class="slickProyectos">
            <b-row class="carrouselNosotros m-auto">
                <b-col>
                    <VueSlickCarousel v-bind="slickOptions" :arrows="true" :dots="false">
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_1.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_2.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_3.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_4.png" alt="">
                        </div>
                        <div>
                            <img class="img-fluid" src="../assets/imgs/proyecto_5.png" alt="">
                        </div>
                    </VueSlickCarousel>
                </b-col>
            </b-row>
        </b-container>
        <Contact/>
        <div class="whatsapp">
            <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                
            </a>
            <b-button id="popover-target-1">
                <img src="../assets/imgs/whatsapp.png" alt="Whatsapp">
            </b-button>
            <b-popover target="popover-target-1" triggers="hover" placement="top">
                <b>Comunícate a:</b><br><br>
                <a href="https://api.whatsapp.com/send/?phone=526863912095&amp;app_absent=0" target="_blank">
                    Samara    
                </a>
                <br><br>
                <a href="https://api.whatsapp.com/send/?phone=526861924713&amp;app_absent=0" target="_blank">
                    Coto Sur 2
                </a>
            </b-popover>
        </div>
    </div>
</template>

<script>
    import Navbar from '../components/Navbar.vue'
    import Contact from '../components/Contact.vue'
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        components: {
            VueSlickCarousel,
            Navbar,
            Contact
        },
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                }
            }
        }
    }
</script>

<style scoped>
.proyectospage{
    padding-top: 100px;
}
/* BANNER */
.banner{
  min-height: 80vh;
  background-image: url('../assets/imgs/imgfondoproyectos.png'); /* The image used */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.banner-section{
    min-height: 80vh;
    padding: 7%;
}
.banner h4{
  color: #fff;
}
.banner p{
  color: #fff;
}
.factores-section{
    padding-top: 100px;
    max-width: 755px;
}
/* PROYECTOS */
.proyectos{
    padding: 10% 5%;
}
.proyectos .text{
    max-width: 800px;
    margin-bottom: 60px !important;
}
.wrapper-proyectos-logos{
    padding: 2% 10%;
    box-shadow: 0px 14px 38.7px -5px #9C9C9C4D;
    border-radius: 10px;
}
.text-proyectos{
    max-width: 690px;
}
.slickProyectos{
    padding-bottom: 150px;
}
.carrouselNosotros{
    max-width: 70vw !important;
}
@media (max-width: 992px) {
    .proyectospage{
        padding-top: 60px;
    }
}
@media (max-width: 768px) {

}
</style>